export default class {
    _id;
    _mail;
    _tempMail;
    _registryId;
    _content;

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get mail() {
        return this._mail
    }

    set mail(value) {
        this._mail = value
    }

    get tempMail() {
        return this._tempMail
    }

    set tempMail(value) {
        this._tempMail = value
    }

    get registryId() {
        return this._registryId
    }

    set registryId(value) {
        this._registryId = value
    }

    get content() {
        return this._content
    }

    set content(value) {
        this._content = value
    }
}